import React from "react"
import { Alert } from "./Alert"

const ConfirmAlert = (props) => (
  <Alert {...props} description="Are you sure you wish to perform this action?" okLabel="Confirm" />
)

export default ConfirmAlert
